;(function ($) {

    $(document).ready(function(){
        contactMap();
    });
  
    //functions
    function contactMap(){
        if ( document.getElementById('contact-map') ) { 
            mapboxgl.accessToken = "pk.eyJ1IjoiYmxrZGciLCJhIjoiY2s3MjV0cWNxMDNjcTNscGZkbXd4MWdhdCJ9.cNUUBRDow3j71FWy8S3KyA";

            //get coordinates from DOM
            var lat = $('#contact-map').data('lat');
            var lng = $('#contact-map').data('lng');

            var geojson = {
                "type": "FeatureCollection",
                "features": [
                    {
                        "type": "Feature",
                        "properties": {
                            "iconSize": [54, 73]
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates":[lng,lat]
                        }
                    }
                ]
            };

            var map = new mapboxgl.Map({
                container: 'contact-map',
                style: 'mapbox://styles/blkdg/ck5ik5mu20ytt1ipmqh6v0kgm',
                center: [lng,lat],
                zoom: 12
            });

            // add markers to map
            geojson.features.forEach(function(marker) {
                // create a DOM element for the marker
                var el = document.createElement('div');
                el.className = 'marker';
                el.style.backgroundImage = 'url(/wp-content/themes/cmac/assets/images/icons/map-locator.svg)';
                el.style.width = marker.properties.iconSize[0] + 'px';
                el.style.height = marker.properties.iconSize[1] + 'px';

                // add marker to map
                new mapboxgl.Marker(el)
                    .setLngLat(marker.geometry.coordinates)
                    .addTo(map);
            });
        }
    }
  
})(jQuery);
  